// src/components/chat/ChatMessages.tsx
import React, { useEffect, useRef } from 'react';
import ReactMarkdown from 'react-markdown';
import { MessagesContainer, Message, Timestamp } from './styles/ChatStyles';
import { ChatMessage, ChatMessagesProps } from './types/chat';
import { TypingIndicator } from './TypingIndicator';

export const ChatMessages: React.FC<ChatMessagesProps> = ({ 
  messages, 
  isTyping, 
  onRetry,
  onUserActivity
}) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, isTyping]);

  return (
    <MessagesContainer 
      onScroll={onUserActivity}
      onMouseMove={onUserActivity}
      onClick={onUserActivity}
    >
      {messages.map((message: ChatMessage) => (
        <Message 
          key={message.id} 
          isUser={message.sender === 'user'}
          isSystem={message.sender === 'system'}
          status={message.status}
        >
          <div className="content">
            <ReactMarkdown>{message.content}</ReactMarkdown>
          </div>
          <Timestamp className="timestamp">
            {new Date(message.timestamp).toLocaleTimeString()}
          </Timestamp>
          {message.status === 'error' && onRetry && (
            <button 
              onClick={() => onRetry(message.id)}
              className="retry-button"
              aria-label="Retry sending message"
            >
              Retry
            </button>
          )}
        </Message>
      ))}
      {isTyping && <TypingIndicator />}
      <div ref={messagesEndRef} />
    </MessagesContainer>
  );
};
